export const costFilterList = [
    {
        label: "FCFA 5000 - 99,900",
        min: 5000,
        max: 100000
    },
    {
        label: "FCFA 100,000 - 149,900",
        min: 100000,
        max: 150000
    },
    {
        label: "FCFA 150,000 - 199,900",
        min: 150000,
        max: 200000
    },
    {
        label: "FCFA 200,000 - 299,900",
        min: 200000,
        max: 300000
    },
    {
        label: "FCFA 300,000 - 399,900",
        min: 300000,
        max: 400000
    },
    {
        label: "FCFA 400,000 - 499,900",
        min: 400000,
        max: 500000
    },
    {
        label: "FCFA 500,000 - 599,900",
        min: 500000,
        max: 600000
    },
    {
        label: "FCFA 600,000 - 699,900",
        min: 600000,
        max: 700000
    }
]